/** Colour names the studios use, with a swatch to draw next to them. First five = the design's common colours. */
export const COLOUR_SWATCHES: Array<[string, string]> = [
  ["Red", "#b3202e"],
  ["Green", "#2f6b4f"],
  ["White", "#f7f5f0"],
  ["Pink", "#e7a1b5"],
  ["Kora", "#e9dcc0"],
  ["Rani", "#c2185b"],
  ["Maroon", "#6d1a24"],
  ["Orange", "#e0762b"],
  ["Yellow", "#e9c23d"],
  ["Gold", "#c9a227"],
  ["Blue", "#1f4fa0"],
  ["Purple", "#6a3d8f"],
  ["Black", "#1d1d1f"],
  ["Off white", "#efe7d6"],
];

export const COMMON_COLOURS = 5;

const EXTRA_WORDS: Array<[string, string]> = [
  ["peacock", "#0f5c73"],
  ["bottle green", "#1e4d3a"],
  ["navy", "#1d2f5e"],
  ["teal", "#11706f"],
  ["beige", "#e6d7b8"],
  ["cream", "#f3ead2"],
  ["ivory", "#f6f0e1"],
  ["silver", "#b9b9c2"],
  ["grey", "#9a9aa0"],
  ["gray", "#9a9aa0"],
  ["brown", "#7a4b2a"],
  ["mustard", "#d4a017"],
  ["magenta", "#c2185b"],
  ["wine", "#6d1a2e"],
  ["lavender", "#b9a3d6"],
  ["mint", "#a8dcc1"],
  ["sky", "#7fb8e6"],
  ["violet", "#6a3d8f"],
  ["multi", "conic-gradient(#b3202e 0 25%, #2f6b4f 0 50%, #1f4fa0 0 75%, #c9a227 0)"],
];

/**
 * Swatch for a free-text colour ("Green border", "Peacock blue"): the first colour word found, so
 * "Bottle green, red border" is green. Unknown words get a neutral grey.
 */
export function colourSwatch(name: unknown): string {
  const text = String(name || "").toLowerCase();
  if (!text.trim()) return "";
  let best: { at: number; len: number; hex: string } | null = null;
  const consider = (word: string, hex: string) => {
    const at = text.indexOf(word);
    if (at < 0) return;
    const cur = best as { at: number; len: number; hex: string } | null;
    if (!cur || at < cur.at || (at === cur.at && word.length > cur.len)) best = { at, len: word.length, hex };
  };
  EXTRA_WORDS.forEach(([word, hex]) => consider(word, hex));
  COLOUR_SWATCHES.forEach(([word, hex]) => {
    const w = word.toLowerCase();
    // "off white" before "white", so only take plain white when it is not part of off white.
    if (w === "white" && text.includes("off white")) return;
    consider(w, hex);
  });
  const found = best as { hex: string } | null;
  return found ? found.hex : "#c7c7cc";
}
